import React, { useEffect, useState } from 'react';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import Header from './components/Header';
import Navigation from './components/Navigation';
import About from './components/About';
import Services from './components/Services';
import Reviews from './components/Reviews';
import Gallery from './components/Gallery';
import Contact from './components/Contact';
import MainIMG1 from './assets/MainIMG1.jpg';
import MainIMG2 from './assets/MainIMG2.jpg';
// import BG_Img from './assets/BG_Img.jpg';
// import Img1 from './assets/Img1.jpg';
import './App.css';
import './styles.css';


const backgroundImages = [MainIMG1, MainIMG2];

function App() {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentImageIndex((prevIndex) =>
        (prevIndex + 1) % backgroundImages.length
      );
    }, 12000);
    return () => clearInterval(timer);
  }, []);

  return (
    <HelmetProvider>
      <div className="app-container">
        <Helmet>
          <title>Temple Gardening - Zen Landscaping</title>
          <meta
            name="description"
            content="Discover spiritual gardening and Zen landscaping at Home Temple Gardening in Fremantle, Western Australia."
          />
        </Helmet>
        <div
          className="background-image"
          style={{ backgroundImage: `url(${backgroundImages[currentImageIndex]})` }}
        ></div>
        <Navigation />
        <Header
          logoUrl='../assets/HomeTempleLogo.png'
          altText="Home Temple Logo"
        />
        <main className="app-main">
          <section id="about">
            <Helmet>
              <title>About Home Temple Gardening</title>
              <meta
                name="description"
                content="Learn about our mission to create serene Zen gardens in Fremantle, Western Australia."
              />
            </Helmet>
            <About />
          </section>
          <section id="services">
            <Helmet>
              <title>Zen Gardening Services in Fremantle, Western Australia</title>
              <meta
                name="description"
                content="Explore our spiritual gardening, garden maintenance and Zen landscaping services in Perth and Fremantle Western Australia."
              />
            </Helmet>
            <Services />
          </section>
          <section id="reviews">
            <Helmet>
              <title>Client Reviews - Home Temple Gardening</title>
              <meta
                name="description"
                content="Read reviews from clients about our Zen gardening maintenance and handiwork services in Fremantle, Western Australia."
              />
            </Helmet>
            <Reviews />
          </section>
          <section id="gallery">
            <Helmet>
              <title>Zen Garden Maintenance Gallery</title>
              <meta
                name="description"
                content="View our gallery of spiritual Zen garden designs in Fremantle, Western Australia."
              />
            </Helmet>
            <Gallery />
          </section>
          <section id="contact">
            <Helmet>
              <title>Contact Home Temple Gardening</title>
              <meta
                name="description"
                content="Get in touch for Zen landscaping services in Fremantle, Western Australia."
              />
            </Helmet>
            <Contact />
          </section>
        </main>
      </div>
    </HelmetProvider>
  );
}

export default App;